export const DAY = 1;
export const HOUR = 2;
export const MINUTE = 3;
export const STEPPER_TYPES = [
  {
    id: DAY,
    name: 'BOOKING.CAPACITY.TYPES.DAY.NAME',
    description: 'BOOKING.CAPACITY.TYPES.DAY.DESCRIPTION'
  },
  {
    id: HOUR,
    name: 'BOOKING.CAPACITY.TYPES.HOUR.NAME',
    description: 'BOOKING.CAPACITY.TYPES.HOUR.DESCRIPTION'
  },
  {
    id: MINUTE,
    name: 'BOOKING.CAPACITY.TYPES.MIN.NAME',
    description: 'BOOKING.CAPACITY.TYPES.MIN.DESCRIPTION'
  }
];

export default Object.freeze({
  DAY,
  HOUR,
  MINUTE
});
